import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { BasketService } from '../../../services/basket.service';
import { UserService } from '../../../services/user.service';
import { Store } from '../../../store';

const EXCLUDED_PATHS = ['/password/reset'];
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    navigationHistory = [];
    params: any;

    constructor(
        private userService: UserService,
        private basketService: BasketService,
        private router: Router,
        private route: ActivatedRoute,
        private store: Store,
        private authService: AuthService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    ngOnInit() {
        if (this.route.snapshot.queryParams.resetLogin && isPlatformBrowser(this.platformId)) {
            this.authService.logout().subscribe();
        }
        this.navigationHistory = this.store.selectForLocal('navigationHistory');
    }

    authenticated(e) {
        if (e) {
            const user = this.store.selectForLocal('user');

            this.userService.findAddressesByCustomer(user.id).subscribe(({ data }: any) => {
                const userBaskets = JSON.parse(localStorage.getItem('userBaskets'));
                let deliveryAddresses = [];
                const basketByUser = userBaskets?.find((userBasket) => userBasket.userId === user.id);
                let basket;
                const priorBasket = this.store.selectForLocal('basket');

                if (basketByUser) {
                    basket = basketByUser.basket;
                } else {
                    basket = priorBasket;
                }

                basket.customer = user;
                basket.deliveryAddress = undefined;
                basket.billingAddress = undefined;

                if (user.address) {
                    basket.billingAddress = user.address;
                }

                deliveryAddresses = data;

                if (deliveryAddresses.length) {
                    basket.deliveryAddress = deliveryAddresses[0];
                    basket.deliveryPostcode = deliveryAddresses[0].postcode;
                }
                this.store.set('deliveryAddresses', deliveryAddresses);
                this.basketService.saveBasketChanges(basket, 'modalAuth');
                if (this.route.snapshot.queryParams.returnUrl) {
                    this.router.navigate([this.route.snapshot.queryParams.returnUrl]);
                } else if (
                    this.navigationHistory.length &&
                    !this.isSamePath(this.navigationHistory[0], this.router.url) &&
                    !EXCLUDED_PATHS.includes(this.navigationHistory[0])
                ) {
                    this.router.navigate([this.navigationHistory[0]]);
                } else {
                    this.router.navigate(['/']);
                }
            });
        }
    }

    public goToRegister($event?: Event): void {
        $event?.preventDefault();
        this.router.navigate(['/register'], { queryParamsHandling: 'preserve' });
    }

    private isSamePath(url: string, compareTo: string) {
        if (!url || !compareTo) {
            return false;
        }
        const urlParsed = url.split('?')?.length ? url.split('?')[0] : undefined;
        const compareToParsed = compareTo.split('?')?.length ? compareTo.split('?')[0] : undefined;
        if (urlParsed?.length && compareToParsed?.length && urlParsed === compareToParsed) {
            return true;
        }
    }
}
